/* Evotique — helper global AJAX cart + scroll reveal */

function evoAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  var btn = event.currentTarget;
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var countEl = document.getElementById('evo-cart-count');
    if (countEl) countEl.textContent = cart.item_count;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

    var original = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';
    setTimeout(function() {
      btn.innerHTML = original;
      btn.disabled = false;
    }, 1800);
  })
  .catch(function() {
    btn.disabled = false;
  });
}

/* Category hover preview */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.evo-cat-card').forEach(function(card) {
    var preview = card.querySelector('.cat-hover-preview');
    if (!preview) return;

    var hideTimer;

    function show() {
      clearTimeout(hideTimer);
      preview.classList.add('chp-visible');
    }

    function hide() {
      hideTimer = setTimeout(function() {
        preview.classList.remove('chp-visible');
      }, 120);
    }

    card.addEventListener('mouseenter', show);
    card.addEventListener('mouseleave', function(e) {
      if (preview.contains(e.relatedTarget)) return;
      hide();
    });
    preview.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
    preview.addEventListener('mouseleave', function(e) {
      if (card.contains(e.relatedTarget)) return;
      hide();
    });
  });
});

/* Scroll reveal */
document.addEventListener('DOMContentLoaded', function() {
  var revealEls = document.querySelectorAll('.evo-reveal');
  if (!revealEls.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  revealEls.forEach(function(el) { observer.observe(el); });
});
